export default __webpack_public_path__ + "static/paystack_docs_seo_image-428a9dfc98f56fe950828ccfddc1d577.jpg";